import React, { Component } from 'react';
import { Header } from '../header';
import CSSModules from 'react-css-modules';
import style from './layout.scss';

@CSSModules(style)
export default class Layout extends Component {
  
  componentWillMount() {
    const { agent } = this.props;
    if (process.twentify.indexOf(process.target[0]) !== -1) {
      /* window.Intercom('boot', {
        app_id: "npa74ozk",
        name: agent.firstName + ' ' + agent.lastName,
        email: agent.email
      }); */
    }
  }

  render() {
    const { agent, account, params } = this.props;

    return (
      <div styleName="root">
        <Header agent={agent} account={account} params={params}/>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/app/layout.js